import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import smileIcon from 'assets/image/icons/svg/smile-icon.svg'
import { useId, useRef } from 'react'

import { Label } from '../../const'
import css from './style.module.scss'

export function FormEmojiPicker({
	onEmojiClick
}: { onEmojiClick: (emoji: string) => void }) {
	const ref = useRef<HTMLDivElement | null>(null)
	const id = useId()
	return (
		<>
			<button
				aria-label={Label.Emoji}
				className={`${css.emojiTrigger} li-⚪`}
				// @ts-ignore Recheck in React 19
				popovertarget={id}
				popovertargetaction='toggle'
				title={Label.Emoji}
				type='button'
            >
                <img alt='' aria-hidden height={20} src={smileIcon} width={20} />
            </button>

			<div
				className={css.emojiWrapper}
				id={id}
				// @ts-ignore Recheck in React 19
				popover='auto'
				ref={ref}
			>
				<Picker
					data={data}
					onEmojiSelect={({ native: emoji }: { native: string }) => {
						onEmojiClick?.(emoji)
						ref.current?.hidePopover()
					}}
				/>
			</div>
		</>
	)
}
